module.exports = __webpack_public_path__ + "media/audio23.98f3222c.mp3";